import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	card: {
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
	},
	cardBody: {
		display: 'grid',
		gap: SPACE[16],
		gridTemplateColumns: '150px 230px minmax(0, 1fr)',
		padding: `${SPACE[16]}px ${SPACE[20]}px ${SPACE[20]}px`,
	},
	cardColumnTitle: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: SPACE[4],
	},
	cardDescription: {
		lineHeight: 1.5,
		wordBreak: 'break-word',
	},
	cardHeader: {
		alignItems: 'center',
		backgroundColor: THEME.colors.background.main,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		color: THEME.colors.text.main,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.xs,
		justifyContent: 'space-between',
		padding: `${SPACE[8]}px ${SPACE[20]}px`,
	},
	cardHeaderRight: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	cardHeaderTitle: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	cardText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	completeLabel: {
		cursor: 'pointer',
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	completeLabelDone: {
		color: THEME.colors.text.light,
		cursor: 'default',
	},
	completedInfo: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	container: {
		paddingBottom: SPACE[40],
	},
	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 1100,
		width: '100%',
	},
	emptyState: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${SPACE[40]}px 0`,
		textAlign: 'center',
	},
	exportButton: {
		color: THEME.colors.text.main,
	},
	triggerFill: {
		width: '100%',
	},
	fill: {
		flex: 1,
	},
	filter: {
		alignItems: 'flex-end',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[16],
		paddingBottom: SPACE[20],
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	filterGroupCategory: {
		width: 220,
	},
	filterGroupDate: {
		width: 230,
	},
	filterGroupStatus: {
		width: 160,
	},
	filterGroupUser: {
		width: 230,
	},
	filterLabel: {
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		lineHeight: 1,
	},
	leadLink: {
		color: THEME.colors.primary.main,
		textDecoration: 'underline',
		':hover': {
			opacity: 0.8,
		},
	},
	listItem: {
		paddingTop: SPACE[12],
	},
	loadingSpinner: {
		marginTop: SPACE[32],
	},
});
